import { fetchPageDataFactory } from './v4BaseAction';
/**
 * Actions for showing modals that use v4 API
 */
export var MODAL_PAGE_DATA_ACTIONS;
(function (MODAL_PAGE_DATA_ACTIONS) {
    MODAL_PAGE_DATA_ACTIONS["REQUEST"] = "MODAL_PAGE_DATA_V4_REQUEST";
    MODAL_PAGE_DATA_ACTIONS["SUCCESS"] = "MODAL_PAGE_DATA_V4_SUCCESS";
    MODAL_PAGE_DATA_ACTIONS["ERROR"] = "MODAL_PAGE_DATA_V4_ERROR";
    MODAL_PAGE_DATA_ACTIONS["CLEAR"] = "MODAL_PAGE_DATA__V4_CLEAR";
})(MODAL_PAGE_DATA_ACTIONS || (MODAL_PAGE_DATA_ACTIONS = {}));
export const fetchModalPageData = fetchPageDataFactory(MODAL_PAGE_DATA_ACTIONS.REQUEST, MODAL_PAGE_DATA_ACTIONS.SUCCESS, MODAL_PAGE_DATA_ACTIONS.ERROR);
export function clearModalPageData(clearModalOptions = false) {
    return {
        type: MODAL_PAGE_DATA_ACTIONS.CLEAR,
        clearModalOptions
    };
}
export function fetchSubPageModalData(subPageResponseData, pageUri, extraOptions) {
    return Object.assign({ url: pageUri, type: MODAL_PAGE_DATA_ACTIONS.SUCCESS, data: subPageResponseData }, (extraOptions || {}));
}
export var modalActions;
(function (modalActions) {
    modalActions["HANDLE_MODAL_ACTION"] = "HANDLE_MODAL_ACTION";
    modalActions["CLEAR_MODAL_ACTION"] = "CLEAR_MODAL_ACTION";
})(modalActions || (modalActions = {}));
export function handleModalAction(action) {
    return Object.assign({ type: modalActions.HANDLE_MODAL_ACTION }, action);
}
export function clearModalAction() {
    return {
        type: modalActions.CLEAR_MODAL_ACTION
    };
}
